import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { BonusSection } from './components/BonusSection';
import { ValueStack } from './components/ValueStack';
import { FinalOffer } from './components/FinalOffer';
import { LeafIcon } from './components/Icons';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1404742387373119');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-white-soft" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedApproaches data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <ValueStack data-id="element-11" />
      <FinalOffer data-id="element-12" />
      <FAQSection data-id="element-13" />

      {/* Footer */}
      <footer className="w-full bg-brown-dark py-10 px-6" data-id="element-14">
        <div className="max-w-2xl mx-auto text-center" data-id="element-15">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-16">
            <LeafIcon className="w-5 h-5 text-gold" data-id="element-17" />
            <span className="font-heading text-lg text-gold font-semibold" data-id="element-18">
              Rescate Capilar 60+
            </span>
          </div>
          <p className="font-body text-sm text-brown-light" data-id="element-19">
            Este producto es informativo y no reemplaza el consejo médico
            profesional.
          </p>
          <p className="font-body text-xs text-brown-light/60 mt-2" data-id="element-20">
            Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}